import React from 'react';
import './App.css';
import SocialIcons from './components/SocialIcons';
import Summary from './components/Summary';
import ProfessionalExperience from './components/ProfessionalExperience';
import Education from './components/Education';
import PersonalInterests from './components/PersonalInterests';

function App() {
  return (
    <div className="App">
      <SocialIcons />
      <h1>Jessica Sarah</h1>
      <Summary />
      <ProfessionalExperience />
      <Education />
      <PersonalInterests />
    </div>
  );
}

export default App;

